import React from 'react'
import { connect } from "react-redux"
import ReactGA from 'react-ga';

import * as appActionCreators from "../actionCreators/app.js"
import * as authActionCreators from "../actionCreators/auth.js"

import FieldInputText from '../components/common/FieldInputText'
import FieldPassword from '../components/common/FieldPassword'

import { Button } from 'primereact/button'
import { Card } from 'primereact/card'
import { Message } from 'primereact/message'

import { Form } from 'react-form'

import '../css/forgot-password.css'

class ForgotPassword extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      // flag stored at container level because we want to know when the container itself has loaded so we can hide/show based on that
      // this way any loading done by child components doesn't cause the container to be hidden
      hasLoaded: false,
      isTokenValid: false
    }
  }

  sendPasswordLink = forgotPasswordDetails => {
    this.props.setLoading(true)
      .then(() => this.props.sendPasswordLink(forgotPasswordDetails.Email))
      .then(response => {
        this.props.setAjaxResponse(response)
        this.props.setLoading(false)
        if (response.data.Success) {
          this.props.history.push('/')
        }
      })
      .catch((error) => this.props.handleError(error)
        .then(() => this.props.setLoading(false)))
  }

  resetPassword = details => {
    let token = this.props.match.params.token
    details.Token = token
    this.props.setLoading(true)
      .then(() => this.props.resetPassword(details))
      .then(response => {
        this.props.setAjaxResponse(response)
        this.props.setLoading(false)
        if (response.data.Success) {
          this.props.history.push('/')
        }
      })
      .catch((error) => this.props.handleError(error)
        .then(() => this.props.setLoading(false)))
  }

  componentDidMount() {
    let token = this.props.match.params.token
    if (token) {
      this.props.setLoading(true)
        .then(() => this.props.checkTokenValidity(token))
        .then(response => {
          this.props.setAjaxResponse(response)
          this.props.setLoading(false)
          if (response.data.Success) {
            this.setState({ isTokenValid: true })
          }
        })
        .catch((error) => this.props.handleError(error)
          .then(() => this.props.setLoading(false)))
    } else {
      // is invoked immediately after a component is mounted. 
      // Initialization that requires DOM nodes should go here. If you need to load data from a remote endpoint, this is a good place to instantiate the network request.   
      this.props.setLoading(true)
        .then(() => this.props.getForgotPasswordDetails())
        .then(() => this.props.setLoading(false))
        .then(() => this.setState({ hasLoaded: true }))
        .catch((error) => this.props.handleError(error))
        .then(() => this.props.setLoading(false))
    }
    this.initializeReactGA();
  }

   initializeReactGA() {
    ReactGA.initialize(this.props.systemParameter.googleAnalyticsTrackingCode);
    ReactGA.pageview(window.location.pathname + 'ForgotPassword');
 }

  render() {
    let token = this.props.match.params.token
    // check if change password details. If not create an empty object to deal with issues that could be caused by annualReturn being undefined
    let forgotPasswordDetails = this.props.auth.forgotPasswordDetails || {}
    let validationRules = forgotPasswordDetails.ValidationRules ? forgotPasswordDetails.ValidationRules.$values : []
    return (
      <React.Fragment>
        {!token && this.state.hasLoaded && <Form values={forgotPasswordDetails} onSubmit={this.sendPasswordLink}>
          {formApi => {
            return (
              <Card className={'forgot-password-card'}>
                <div className="p-grid">
                  <div className="p-col-12">
                    <FieldInputText field={"Email"} label={"Please enter your Email Address:"} validationRules={validationRules} />
                  </div>
                  <div className="p-helper-clearfix buttons">
                    <Button label="Send Reset Link" onClick={formApi.submitForm} style={{marginLeft: '11px'}}/>
                  </div>
                </div>
              </Card>
            )
          }}
        </Form>}
        {token && this.state.isTokenValid && <Form values={this.state.details} onSubmit={this.resetPassword}>
          {formApi => {
            return (
              <Card className={'forgot-password-card'}>
                <div className="p-grid">
                  <div className="p-col-12">
                    <Message style={{ width: '100%' }} severity="" text="Password must be at least 8 characters, contain 1 digit, contain 1 uppercase letter and contain 1 lowercase letter."></Message>
                  </div>
                  <div className="p-col-12 ui-md-12 ui-lg-12">
                    <FieldPassword field={"Password"} label={"Please enter your New Password"} />
                  </div>
                  <div className="p-col-12 ui-md-12 ui-lg-12">
                    <FieldPassword field={"ConfirmPassword"} label={"Please confirm your New Password:"} />
                  </div>
                  <div className="p-helper-clearfix buttons" style={{margin:"12px"}}>
                    <Button label="Reset Password" onClick={formApi.submitForm} />
                  </div>
                </div>
              </Card>
            )
          }}
        </Form>}
      </React.Fragment>
    )

  }
}

const mapStateToProps = (state) => {
  return state
}

const actionCreators = {
  ...appActionCreators,
  ...authActionCreators
}

export default connect(mapStateToProps, actionCreators)(ForgotPassword);


// WEBPACK FOOTER //
// ./src/container/ForgotPassword.js